exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red[data-v-4c70729a]{background-color:red}", ""]);

// exports
